"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.employeeFunctionValidator = employeeFunctionValidator;
exports.employeementTypeValidator = employeementTypeValidator;
exports.genderValidator = genderValidator;
exports.statusValidator = statusValidator;
exports.workPercentageValidator = workPercentageValidator;
exports.yearValidator = yearValidator;
function yearValidator(year) {
  const yearRegex = /^\d{4}$/;
  return yearRegex.test(year);
}
function genderValidator(genderCode) {
  const genderCodes = ['f', 'm'];
  return genderCodes.includes(genderCode);
}
function workPercentageValidator(workPercentage) {
  const threeDigitsRegex = /^\d{0,3}$/;
  return threeDigitsRegex.test(workPercentage.toString());
}
function employeementTypeValidator(employeementCode) {
  const employeementCodes = [5,
  //	Büroinhaber
  2,
  //	Lehrlinge
  3,
  //	Mitarbeitende
  1,
  //	Praktikanten
  4 //	Teilhaber
  ];
  return employeementCodes.includes(employeementCode);
}
function statusValidator(statusCode) {
  const statusCodes = [1,
  // Ausbildung
  2,
  // Einsteiger
  5,
  // Erw. Geschäftsleitung
  6,
  // Geschäftsleitung
  3,
  // Normal
  4 // Teamleitung
  ];
  return statusCodes.includes(statusCode);
}
function employeeFunctionValidator(functionCode) {
  const functionCodes = [26,
  // Gesamtprojektleiter
  1,
  // Projektleiter
  27,
  // Teilprojektleiter
  2,
  // Architekt
  3,
  // Bautechniker
  4,
  // Zeichner
  5,
  // Bauleiter
  32,
  // Hilfsbauleiter
  7,
  // Administrationspersonal
  9,
  // Hilfspersonal
  28,
  // Chefingenieur
  15,
  // Ingenieur
  16,
  // Konstrukteur
  29,
  // Chefbauleiter
  6,
  // Hilfsbauleiter / Bauaufseher
  30,
  // Chefadministrator
  13,
  // Landschaftsarchitekt
  14,
  // Landschaftsbauzeichner
  17,
  // Prüfingenieur
  10,
  // Raumplaner
  18,
  // Umweltfachmann
  31,
  // Projektleiter / Geomatiktechniker
  20,
  // Geomatiker
  21,
  // Informatiker
  23,
  // Bauzeichner
  25,
  // Messassistent
  33,
  // Akustiker
  34,
  // Brandschutzplanner
  35,
  // Bauphysiker
  36,
  // Consultant
  37,
  // Disponenten
  38,
  // Fachverantwortliche Finance & Controlling
  39,
  // Fachverantwortliche HR
  40,
  // Holzbauingenieur
  41,
  // ICT-Techniker
  42,
  // Kaufm. Sachbearbeiter VDM
  43,
  // Landschaftsarchitekt
  44,
  // Massivbauingenieur
  45,
  // Produktionsentwickler Energie & ZEV
  46,
  // Projektleiter Mobilität & Logistik
  47,
  // Projektleiter Verkauf / VDM
  48,
  // Servicetechniker
  49,
  // Verkehrsplaner
  50,
  // Verkehrsingenieur
  51,
  // Innenarchitekt:in
  52,
  // BIM-Koordinator:in
  53 // Kommunikationsverantwortliche:r
  ];
  return functionCodes.includes(functionCode);
}